import React from 'react';
import styles from './PrivacySection.module.css';

const PrivacySection = () => {
  return (
    <section className={styles.privacy}>
      <div className={styles.container}>
        <div className={styles.content}>
          <h2 className={styles.title}>Privacy Policy</h2>
          <p className={styles.effectiveDate}>Effective Date: February 14, 2025</p>

          <div className={styles.prose}>
            <h3 className={styles.subtitle}>1. Introduction</h3>
            <p className={styles.bodyText}>
              Welcome to Subwise ("we", "our", "us"). Your privacy is important to us. This Privacy Policy explains how we collect, use, and protect your information when you use our iOS application.
            </p>

            <h3 className={styles.subtitle}>2. Information We Collect</h3>
            <p className={styles.bodyText}>
              We do not collect any personal data or store any information saved by the user. All the data is saved locally in the device and only the user has access to it.
            </p>

            <h3 className={styles.subtitle}>3. How We Use Information</h3>
            <p className={styles.bodyText}>
              Since we do not collect any personal data, we do not use, share, or disclose any user information.
            </p>

            <h3 className={styles.subtitle}>4. Data Security</h3>
            <p className={styles.bodyText}>
              We prioritize the security of your data. Although we do not collect or store your data, we ensure that the app operates in a secure environment, adhering to industry standards to protect against unauthorized access, alteration, or destruction of any local data.
            </p>

            <h3 className={styles.subtitle}>5. Changes to This Privacy Policy</h3>
            <p className={styles.bodyText}>
              We may update our Privacy Policy from time to time. Any changes will be posted on this page, and the effective date will be updated accordingly. We encourage you to review this Privacy Policy periodically for any changes.
            </p>

            <h3 className={styles.subtitle}>6. Contact Us</h3>
            <p className={styles.bodyText}>
              If you have any questions or concerns about this Privacy Policy, please contact us at:
            </p>
            <p className={styles.bodyText}>
              <a href="mailto:contact@mutarelabs.com?subject=Privacy%20Policy%20Inquiry" className={styles.link}>
                contact@mutarelabs.com
              </a>
            </p>
            <p className={styles.bodyText}>
              By using Subwise, you agree to the terms of this Privacy Policy. If you do not agree with this policy, please do not use our application.
            </p>

            <h3 className={styles.subtitle}>7. Third-Party Links</h3>
            <p className={styles.bodyText}>
              Our app does not contain links to third-party websites or services. If this changes in the future, we will update our Privacy Policy accordingly.
            </p>

            <h3 className={styles.subtitle}>8. Children's Privacy</h3>
            <p className={styles.bodyText}>
              Our app is intended to be for age rating of +4. We do not knowingly collect personal data and the app is safe as it is not collecting or has any kind of in-app payments. If there is some change in the future, the age rating will be changed in the App Store and in this privacy policy.
            </p>

            <h3 className={styles.subtitle}>9. User Consent</h3>
            <p className={styles.bodyText}>
              By using our application, you consent to our Privacy Policy.
            </p>

            <h3 className={styles.subtitle}>10. Compliance with Laws</h3>
            <p className={styles.bodyText}>
              We comply with applicable data protection and privacy laws and regulations. This includes, but is not limited to, the General Data Protection Regulation (GDPR) for users in the European Union and the California Consumer Privacy Act (CCPA) for users in California.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PrivacySection;
